export default __webpack_public_path__ + "static/media/invite-friend.bf858971.svg";